/* eslint-disable */
import $ from 'jquery';
import { EXPAND, LINE_TYPE, MARKER_TYPE } from './const';


C.poiColl = C.poiColl || {};
const poi_data = C.poiColl.data || C.poiColl || {};

var PoiColl = {
  collElem             : $("#poiColl"),
  mapData              : [],
  map                  : null,
  markers              : [],
  infoWindows          : [],
  init                 : function () {
    poi_data.map.markers.forEach(marker => this.addMapData(marker));
    this.bindEvents();
  },
  bindEvents           : function () {
    // map controls event.
    const $mapControls = this.collElem.find('.tool_map');
    const $mapArea = this.collElem.find('#poiCollMapArea');
    
    $mapControls.find('.btn_enlarge').on('click', e => this.zoomIn());
    $mapControls.find('.btn_reduce').on('click', e => this.zoomOut());
    // list type ui event
    const $placeList = this.collElem.find('.wrap_place');
    $placeList.on('click', '.link_more', this.onToggleAddressLayer($placeList));
    
    // toggle biz
    $placeList.filter((i, elem) => $(elem).hasClass('wrap_ad')).find('.expender').on('click', this.onToggleExpand($placeList.find('.biz_others')));
  
    // move marker entering mouse over li elements.
    $placeList.not('.wrap_ad').find('li').on('mouseenter', e => this.onPoiMouseEnter(e));
    
    // yellow biz info layer
    $placeList.find('.link_kakao').on('click', function () {
      $(this).siblings('.layer_kakao').toggleClass('hide');
    });
  
    $placeList.find('.layer_kakao .btn_close').on('click', function (e) {
      $(this).parent('.layer_kakao').addClass('hide');
    });
    
    // close info window
    $mapArea.on('click', '.btn_close', e => this.closeInfoWindow("pickInfoWnd"));
    
    // ad info layer
    const $infoAddContext = this.collElem.find('.info_adsch');
    const $infoAddLayer = $infoAddContext.find('#poiAdGuide');
    $infoAddContext.find('.ico_info').on('click', function () {
      $infoAddLayer.toggleClass('hide');
    });
    $infoAddContext.find('.btn_close').on('click', function () {
      $infoAddLayer.addClass('hide');
    });
  
  
    // same name region selector
    this.collElem.find('#poi_regions').on('change', this.changeOtherRegion);
  
    // view more poi
    const $btnExpand = this.collElem.find('.poi_extend');
    if ( $btnExpand.length > 0 ) {
      let page = EXPAND.START_OF_PAGE;
      this.initExpander($placeList.not('.wrap_ad').find('ul'), $btnExpand, function (response) {
        const { wx, wy, lcode, meta : { isRealPos } } = C.poiColl;
        const qsPrams = $.extend({
          coll   : 'poi',
          m      : C.poiColl.DA.poi,
          p      : page,
          offset : C.poiColl.meta.offset,
          n      : EXPAND.COUNT_PER_PAGE,
          type   : 'list',
          viewsite
        }, isRealPos ? {
          wx,
          wy,
          lcode
        } : {});
  
        $.ajax({
          url      : SF.getQsUrl(qsPrams, 2),
          dataType : 'html'
        }).done((html, textStatus) => {
          if ( textStatus === 'success' ) {
            const $htmlWrapper = $('<div></div>').append(html);
            response($htmlWrapper.find('li'), ($html => {
              return $html.find(`.${EXPAND.FLAG_IS_END}`).length > 0 || page === EXPAND.END_OF_PAGE;
            })($htmlWrapper));
            page += 1;
          } else {
            response(null);
            throw new Error(textStatus);
          }
        }).fail((jqXHR, textStatus) => {
          response(null);
          throw new Error(textStatus);
        });
      });
    }
  },
  initExpander         : function ($container, $button, callback) {
    // expand log
    $button.find('.expender').on('click', e => {
      const $elem = $(e.currentTarget);
      $elem.hasClass('open') ? smartLog(e.currentTarget, this.makeExpandLogStr($container, 90), e) : smartLog(e.currentTarget, this.makeExpandLogStr($container, 91), e);
    });
    
    // load expand list
    new SF.extend({
      expender  : $button,
      container : $container,
      viewCount : EXPAND.COUNT_PER_PAGE,
      source    : callback
    });
  },
  makeExpandLogStr     : function ($container, e) {
    return `a=LOTO&dc=${C.poiColl.DA.poi}&pg=${parseInt($container.find('li').length / EXPAND.COUNT_PER_PAGE, 10)}&s=TO&rc=${$container.find('li').length}&ext=${C.poiColl.meta.extfreeLog}&e=${e}&at=func`;
  },
  onPoiMouseEnter      : function (e) {
    this.moveMarker($(e.currentTarget).index());
  },
  onToggleAddressLayer : function ($placeList) {
    return function (e) {
      const $addrLayer = $placeList.find('.layer_more');
      const $btnToggleAddrLayer = $placeList.find('.link_more');
      const index = $btnToggleAddrLayer.index(this);
      $addrLayer.eq(index).toggleClass('hide').toggleClass('open_layer');
      $addrLayer.filter((i, elem) => (i !== index) && $(elem).hasClass('open_layer'))
        .removeClass('open_layer').addClass('hide');
    }
  },
  onToggleExpand       : function ($items) {
    return function (e) {
      $(this).toggleClass('open').toggleClass('close');
      $items.toggleClass('hide');
    }
  },
  zoom                 : function (level) {
    const MAX = 15;
    const MIN = 1;
    if ( level < MAX && level > MIN ) this.map.setLevel(level);
  },
  zoomIn               : function () {
    this.zoom(this.map.getLevel() - 1);
  },
  zoomOut              : function () {
    this.zoom(this.map.getLevel() + 1);
  },
  addMapData           : function (obj) {
    obj.position = new daum.maps.Coords(obj.wx, obj.wy);
    this.mapData.push(obj);
  },
  
  render : function (center) {
    var map = this.makeMap(center), self = this;
    var bounds = new daum.maps.CoordsBounds();
    
    // 마커 생성
    $.each(this.mapData, function (i, data) {
      var marker = self.makeMarker(data);
      self.markers.push(marker);
    });
    
    // 데이터 역순으로 마커와 라인을 지도에 그림.첫번째마커를 지도 가장 위에 올리기 위해서 마지막에 생성함
    for ( var idx = this.markers.length - 1; idx >= 0; idx-- ) {
      var marker = this.markers[idx];
      this.markers.length > 1 && bounds.extend(marker.getPosition());
      marker.setMap(map);
      marker.line = self.renderLine(idx, marker, bounds);
      self.bindMarkerEvent(marker, idx);
    }
  
    bounds.isEmpty() || map.setBounds(bounds);
    this.map = map;
  },
  
  bindMarkerEvent : function (marker, idx) {
    var self = this, data = self.mapData[idx];
    daum.maps.event.addListener(marker, 'click', function () {
      if ( data.marker_type === "exact" ) {
        self.clickLogP(data, 65, "func");
        window.open('http://place.map.daum.net/' + self.mapData[idx].docid).focus();
        return;
      }
      self.panTo(marker);
      self.closeInfoWindow("mouseoverInfoWnd");
      self.closeInfoWindow("pickInfoWnd");
      self.renderInfoWindow(idx, "pickInfoWnd");
      marker.setZIndex(10);
      self.clickLogP(data, 65, "func");
    });
    daum.maps.event.addListener(marker, 'mouseover', function () {
      self.renderInfoWindow(idx, "mouseoverInfoWnd");
      self.activateLine(marker);
      marker.setZIndex(10);
    });
    daum.maps.event.addListener(marker, 'mouseout', function () {
      self.closeInfoWindow("mouseoverInfoWnd");
      self.deactivateLine(marker);
      marker.setZIndex(3);
    });
    
    $('#poiOpenTimeBtn').click(function () {
      $('#poiOpenTable').toggleClass('hide');
    });
    
    $('#poiMenuBtn').click(function () {
      self.collElem.find('.layer_menu').toggleClass('hide');
    });
  },
  
  makeMarker : function (d) {
    return new daum.maps.Marker({
      position : d.position,
      image    : this.getMarkerImageUrl(d),
      zIndex   : 3
    });
  },
  
  getMarkerImageUrl : function (d) {
    const { src, w, h, x, y } = MARKER_TYPE[d.marker_type];
    
    return new daum.maps.MarkerImage(
      src.replace("#", (parseInt(d.idx, 10) + 1).toString()),
      new daum.maps.Size(w, h),
      new daum.maps.Point(x, y));
  },
  
  renderInfoWindow : function (idx, templateId) {
    var data = this.mapData[idx];
    var self = this;
  
    var tmpl = SF.M.tmpl(templateId, {
      poi : {
        placeName        : data.title,
        address          : data.addr,
        url              : "http://place.map.daum.net/" + data.docid,
        titleBtnClickLog : this.makeClickLogString(data, 74, "link"),
        closeBtnClickLog : this.makeClickLogString(data, 88, "func")
      }
    });
    
    var infoWnd = new SF.M.customInfoWindow(this.map, data.position, tmpl, function (node, point) {
      self.modifyPositionInfoWindow(node, point, MARKER_TYPE[data.marker_type]);
    }, this);
    infoWnd.setMap(this.map);
    infoWnd.templateId = templateId;
    
    this.infoWindows.push(infoWnd);
  },
  
  modifyPositionInfoWindow : function (node, point, markerOpt) {
    node.style.cssText = 'position: absolute; z-index:999;cursor:default;';
    var width = node.offsetWidth;
    var height = node.offsetHeight;
    node.style.left = point.x - ( width / 2 ) + 'px';
    node.style.top = ( point.y - (markerOpt.h * 1.2 + height)) + 'px';
  },
  
  closeInfoWindow : function (targetTemplateId, callback) {
    var self = this;
    $.each(self.infoWindows, function (i, v) {
      if ( v.templateId == targetTemplateId ) {
        v.onRemove();
        self.infoWindows.splice(self.infoWindows.indexOf(v), 1);
      }
    });
  },
  
  makeMap : function (center) {
    if ( this.map ) {
      return this.map;
    }
    var mapElem = $('#poiCollMapArea').get(0);
    return new daum.maps.Map(mapElem, {
      center      : (center) ? center : this.getCenter(),
      scrollwheel : false,
      level       : 4
    });
  },
  
  panTo : function (marker) {
    //y값 위치보정(지도 height가 낮아서 인포윈도우가 가려짐)
    var infoWindowOffset = 50;
    var projection = marker.getProjection();
    var coords = marker.getPosition();
    var point = projection.pointFromCoords(coords);
    point.y -= infoWindowOffset;
    marker.getMap().panTo(projection.coordsFromPoint(point));
  },
  
  getCenter         : function () {
    return this.mapData[0].position;
  },
  changeOtherRegion : function () {
    const $this = $(this);
    location.href = $this.data('url') + $this.find('option:selected')[0].value;
  },
  
  renderLine : function (i, marker, bounds) {
    if ( !this.mapData[i].line_data ) {
      return;
    }
    var map = marker.getMap();
    
    // 라인 정보를 지도 bounds에 포함하여 level결정
    var lineInfo = this.parseLineInfo(i);
    this.putLineOnBounds(lineInfo.lineBounds, bounds);
    
    // 라인의 시작점, 종착점 마커 생성
    this.makeMarker({
      idx         : -1,
      position    : lineInfo.startPoint,
      marker_type : "lineDot"
    }).setMap(map);
    
    this.makeMarker({
      idx         : -1,
      position    : lineInfo.endPoint,
      marker_type : "lineDot"
    }).setMap(map);
    
    // 장소 마커를 라인 중심으로 이동
    this.transMarkerOnLine(lineInfo, marker);
    this.mapData[i].position = lineInfo.center;
    
    // 지도 그리기
    return this.makeLine(lineInfo, map);
  },
  
  makeLine          : function (li, map) {
    var line = [];
    var opt = {
      strokeColor   : '#FE378A',
      strokeWeight  : 3,
      strokeOpacity : 0.5
    };
    for ( var i = 0; i < li.positions.length; i++ ) {
      line[i] = new daum.maps.Polyline();
      line[i].setOptions(opt);
      line[i].setPath(li.positions[i]);
      line[i].setMap(map);
    }
    return line;
  },
  transMarkerOnLine : function (lineInfo, marker) {
    marker.setPosition(lineInfo.center);
  },
  putLineOnBounds   : function (line, bounds) {
    $.each(line, function (i, v) {
      bounds.extend(v);
    });
  },
  
  /**
   * 장소용 폴리라인을 생성하는 함수
   * 장소 라인 데이터 - center^start^end^line1@line2@line3^bound@bound
   * Legacy Code -- 일단 그냥 쓰기
   * TODO: this.line_position은 어디서 쓰지????
   * TODO: center, start, end 사용처 확인. 없으면 빼자.
   */
  parseLineInfo      : function (data_index) {
    var data = this.mapData[data_index],
      line_data = data.line_data;
    
    var arr_line_data = line_data.split("^");
    var center = new daum.maps.Coords(arr_line_data[0].split(",")[0], arr_line_data[0].split(",")[1]);
    var startp = new daum.maps.Coords(arr_line_data[1].split(",")[0], arr_line_data[1].split(",")[1]);
    var endp = new daum.maps.Coords(arr_line_data[2].split(",")[0], arr_line_data[2].split(",")[1]);
    var temp_lines = arr_line_data[3].split("@");
    var bounds = arr_line_data[4].split("@");
    
    /* line 추출. line은 x,y|x,y 구조 */
    var line_set = [];
    for ( var j = 0; j < temp_lines.length; j++ ) {
      var line_positions = [];
      var line = temp_lines[j].split("|");
      if ( line.length > 1 ) {
        for ( var i = 0, g = line; i < g.length; i++ ) {
          var temp = g[i].split(",");
          line_positions.push(new daum.maps.Coords(temp[0], temp[1]));
        }
      }
      line_set.push(line_positions);
    }
    /* bound 추출 */
    var bound_set = [];
    for ( var j = 0; j < bounds.length; j++ ) {
      var temp = bounds[j].split(",");
      if ( temp.length == 2 ) {
        bound_set.push(new daum.maps.Coords(temp[0], temp[1]));
      }
    }
    return {
      positions  : line_set,
      center     : center,
      startPoint : startp,
      endPoint   : endp,
      lineBounds : bound_set
    }
  },
  activateLine       : function (marker) {
    marker.line && $.each(marker.line, (i, v) => v.setOptions(LINE_TYPE.ACTIVE));
  },
  deactivateLine     : function (marker) {
    marker.line && $.each(marker.line, (i, v) => v.setOptions(LINE_TYPE.DE_ACTIVE));
  },
  moveMarker         : function (idx) {
    this.smallerMap13Level() || this.panTo(this.markers[idx]);
  },
  smallerMap13Level  : function () {
    return this.map.getLevel() < 13;
  },
  clickLogP          : function (data, pVal, actionType) {
    eval(this.makeClickLogString(data, pVal, actionType));
  },
  makeClickLogString : function (data, pVal, actionType) {
    var isBizMarker = this.isBizMarkerType(data);
    var dc = isBizMarker ? poi_data.DA['biz'] : poi_data.DA['poi'];
    var count = isBizMarker ? poi_data.meta.bizCount : poi_data.meta.poiCount;
    return this.formatter(`smartLog(this, "a=LOTO&pg=1&s=TO&rc=${count}&ext=${poi_data.meta.extfreeLog}&dc={0}&d={1}&r={2}&at={3}&p={4}", event);`,
      dc, data.docid, parseInt(data.idx, 10) + 1, actionType, pVal);
  },
  isBizMarkerType    : function (data) {
    return (data.marker_type === 'premium' || data.marker_type === 'tilePlus');
  },
  formatter          : function (format) {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] !== 'undefined' ? args[number] : match;
    });
  }
};
daum.maps.load(function () {
  SF.M.loadCustomMapInfoWindow();
  PoiColl.init();
  PoiColl.render();
  PoiColl.moveMarker(0);
});



// WEBPACK FOOTER //
// ./src/local/poi/index.js